import { Button, Box, Grid, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import { useWeavingAlertsQuantities } from "../../../../hooks/weaving_alert/use-weaving-alerts-quantities";
import { Badge, Popconfirm } from "antd";
import { format, parseISO } from 'date-fns';
import { useDeleteWeavingAlert } from "../../../../hooks/weaving_alert/use-delete-weaving-alert";
import { getRol } from "../../../../_utils/storage_handler";
import { ROLES } from "../../../../_config/roles";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const ModalAlerts = () => {

    const [openModal, setOpenModal] = useState(false);

    const weavingAlerts = useWeavingAlertsQuantities();
    const deleteAlert = useDeleteWeavingAlert(weavingAlerts.loadData);

    const handleOpen = () => {
        setOpenModal(true);
    }

    const handleClose = () => {
        setOpenModal(false);
    }

    const renderButtonWithBadage = () => {
        return(
            <Badge count={weavingAlerts.data.length}>
                <Button variant="contained" onClick={handleOpen}>
                    Ver alertas
                </Button>
            </Badge>
        )
    }

    const renderActionComponent = (item) => {
        const rol = getRol();
        if([ROLES.root, ROLES.admin, ROLES.tejeduria].includes(rol)){
            return(
                <Popconfirm
                    title={'Eliminar alerta'}
                    onConfirm={() => {
                        deleteAlert.deleteAlert(item?.uuid);
                    }}
                    onVisibleChange={() => {}}
                    overlayStyle={{ zIndex: 10000 }}
                >
                    <Button variant="contained" color="error">
                        Eliminar
                    </Button>
                </Popconfirm>
            );
        }

        return <>Para eliminar, comuníquese con el administrador o con tejeduría</>
    }

    return (
        <div>
            {
                weavingAlerts.data.length > 0 &&
                renderButtonWithBadage()
            }
            <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container spacing={1}>
                        <TableContainer>
                            <div style={{ height: '500px', overflowY: 'auto' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Referencia</TableCell>
                                        <TableCell>Cantidad crudo (MTS)</TableCell>
                                        <TableCell>Cantidad enrollado (MTS)</TableCell>
                                        <TableCell>Desactivar</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {weavingAlerts.data.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ fontSize: '0.8em' }}>{format(parseISO(item?.created_at), 'dd-MM-yyyy HH:mm:ss')}</TableCell>
                                            <TableCell>{item?.product}</TableCell>
                                            <TableCell>{item?.crude_quantity}</TableCell>
                                            <TableCell>{item?.rolled_quantity}</TableCell>
                                            <TableCell>
                                                {renderActionComponent(item)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>    
                            </Table>
                            </div>
                        </TableContainer>
                    </Grid>
                </Box>
            </Modal>
        </div>
    )
}

export default ModalAlerts;
